import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { t } from 'i18next'

import { PostReservaProdutoService } from '@/features/produtos/services/post-reserva-produto.service'
import { produtosKeys } from '@/features/produtos/utils/queries'
import { showToast } from '@/shared/lib/sonner'

export const useReservaProduto = () => {
  const queryClient = useQueryClient()
  return useMutation<unknown, AxiosError, { idExternoProduto: number }, unknown>({
    mutationKey: produtosKeys.reservaProduto(),
    mutationFn: async ({ idExternoProduto }) =>
      new PostReservaProdutoService().execute(idExternoProduto, {
        reservaPeloVendedor: true,
      }),
    onError: () => {
      showToast({
        variant: 'error',
        message: t('common:errors_gerais.padrao'),
      })
    },
    onSuccess: (_, { idExternoProduto }) => {
      showToast({
        variant: 'success',
        message: t('espelho-de-vendas:detalhes_lote.reserva.modal_reserva.sucesso'),
      })
      queryClient.invalidateQueries({ queryKey: produtosKeys.detalheLote(idExternoProduto) })
      queryClient.invalidateQueries({ queryKey: ['produtos', 'lotes-empreendimento'] })
    },
  })
}
